export default class MicroApp {
  constructor (masterAppProps, options) {
    const defaultOptions = { selfRefresh: false }
    this.options = Object.assign(defaultOptions, options || {})
    this.state = {}
    this.props = masterAppProps
    window.$microAppStore = this
  }

  toBindStateChange ({ rootState, setHeaders, setI18nLanguage, setThemeColor }, callbackChange) {
    const { selfRefresh } = this.options
    const props = this.props
    let isFirstEmit = true
    const { name, moduleCode, authorityCodes } = props

    rootState.moduleCode = moduleCode // todo: 产品全部升级后删除
    rootState.authorityCodes = authorityCodes || [] // todo: 产品全部升级后删除

    this.onStateChange((value, prev) => {
      console.log(`[onGlobalStateChange - ${name}]:`, value, prev)
      const {
        token, tenantId, userId, orgId, orgName, productCode, menuCode, moduleCode, authorityCodes,
        lang, isI18nEnv, orgType, orgFullId, isWidget, themeColor
      } = value
      Object.assign(this.state, value)

      setHeaders && setHeaders(token, orgId || '', productCode, menuCode || '')
      rootState.moduleCode = moduleCode
      rootState.authorityCodes = authorityCodes || []
      rootState.isI18nEnv = isI18nEnv
      rootState.tenantId = tenantId
      rootState.userId = userId
      rootState.orgId = orgId
      rootState.orgName = orgName
      rootState.orgType = orgType
      rootState.orgFullId = orgFullId
      setI18nLanguage && setI18nLanguage(lang)
      setThemeColor && setThemeColor(themeColor)
      // 主应用改变状态时
      if (name !== value.ignore) {
        // 非首次改变状态、主应用要求刷新数据时
        if (!isWidget && !isFirstEmit && value.needRefreshApp) {
          // 自行实现刷新数据
          if (selfRefresh) {
            rootState.refresh = true
            this.setState({
              selfRefresh: true
            })
            // 由主应用重新渲染
          } else {
            this.setState({
              selfRefresh: false
            })
          }
        }
        isFirstEmit = false
      }
      callbackChange && callbackChange(value, prev)
    })
  }

  onStateChange (cb) {
    const props = this.props
    props.onGlobalStateChange && props.onGlobalStateChange(cb, true)
  }

  setState (state) {
    const props = this.props
    props.setGlobalState && props.setGlobalState({
      ...this.state,
      ...state,
      ignore: props.name
    })
  }

  setProductState (productState) {
    const { productsState, productCode } = this.state

    productsState[productCode] = productState

    this.setState({
      productsState: {
        ...productsState
      }
    })
  }

  getProductState () {
    const { productsState, productCode } = this.state

    return productsState[productCode]
  }
}
